import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { SalesConfiguration } from './constants';

export interface TrainingResourcesConfig {
  partnerId$: Observable<string>;
  marketId$: Observable<string>;
  canShowFilesForPartner: ((partnerId: string, fileName: string) => boolean) | boolean;
  salesConfiguration$: Observable<SalesConfiguration>;
}

export const TRAINING_RESOURCES_CONFIG_TOKEN = new InjectionToken<TrainingResourcesConfig>(
  'training resources config token',
);
